import React, { useState, useEffect } from 'react';
import Card from '../common/Card.redesign';
import Project from 'src/models/Project';
// import { ContextMenuAction } from '../common/ContextMenu';
import Button from '../controls/forms/redesign/FormButton';
import County from 'src/models/County';
import { ContextMenuAction } from '../common/ContextMenu';

interface IProjectCardProps {
    project: Project;
    key?: string;
    onEditProjectClick: () => void;
    onAdministerProjectClick: () => void;
    editProject?: (id: number) => void;
    handleFavorite: () => void;
}

const ProjectCard = (props: IProjectCardProps) => {
    const actionName = props?.project?.isFavorite === true ? 'Remove Favorite' : 'Add Favorite';

    const menuActions: ContextMenuAction[] = [{ text: actionName, action: () => props.handleFavorite() }];
    const [countyNames, setCountyNames] = useState<Array<County>>(null);

    useEffect(() => {
        if (props?.project?.counties && props?.project?.counties?.length > 0) {
            setCountyNames(props.project.counties);
        }
    }, [props.project.counties]);

    const rightBadgePanel = () => {
        if (props.project.updateNeeded === true) {
            return (
                <div style={{ display: 'flex', columnGap: '3rem', alignItems: 'center', marginRight: '3rem' }}>
                    <div>{props.project.state?.name}</div>
                    <div style={{ padding: '.4rem', background: 'yellow', fontWeight: 'bold', fontSize: '.8em' }}>Setup Required</div>
                </div>
            );
        }

        return (
            <div style={{ display: 'flex', columnGap: '3rem', alignItems: 'center', marginRight: '3rem' }}>
                <div>{props.project.state?.name}</div>
            </div>
        );
    };

    const infoBarPanel = () => {
        const infoBar = (
            <div>
                <span className="title">{props.project.name}</span> {countyNames && displayCountyNames()}
                {props.project?.isFavorite && (
                    <div 
                        className="icon-panel" 
                        style={{ display: 'inline-block' }}
                    >
                        <i className="fas fa-star" />
                    </div>
                )}
            </div>        
        );

        // if (props.project.updateNeeded === true) {
        //     return <div />;
        // }

        return infoBar;
    };

    const displayCountyNames = () => {
        return '-' + countyNames.map((x) => {
            return x.name;
        })
        .toString()
        .replace(/,/g, ', ');
    };

    return (
        <Card
            badge={`${props.project.projectNumber}`}
            contextActions={menuActions}
            newContext={true}
            showMenu={true}
            rightBadgePanel={rightBadgePanel()}
            infoBar={infoBarPanel()}
            style={{ marginTop: '1rem' }}
        >
            {!!props.project && !!props?.project?.updateNeeded === true ? (
                <div style={{ display: 'flex', justifyContent: 'flex-start', marginLeft: '21rem' }}>
                    <div style={{ padding: '.5rem' }}>
                        <Button text="Finish Project Setup" intent="primary" onClick={props.onAdministerProjectClick} />
                    </div>
                </div>
            ) : (
                <div style={{ display: 'flex', justifyContent: 'space-around', padding: '1.5rem', marginBottom: '1rem' }}>
                    <div style={{ padding: '.5rem', height: '2rem' }}>
                        <Button text="Edit Project" intent="primary" onClick={props.onEditProjectClick} />
                    </div>
                    {/* <div style={{ padding: '.5rem' }}>
                        <Button text="Administer Project" intent="primary" onClick={props.onAdministerProjectClick} />
                    </div> */}
                </div>
            )}
        </Card>
    );
};

export default ProjectCard;



// WEBPACK FOOTER //
// ./src/components/cards/ProjectCard.tsx